import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index';
import { Spinner } from '../../../../../common/index';
import ErasmusConsortiumForm from './ErasmusConsortiumForm/ErasmusConsortiumForm.jsx';
import {
  useGetErasmusConsortiumsQuery,
  useGetErasmusConsortiumQuery,
  useSaveErasmusConsortiumMutation,
  useSaveErasmusConsortiumUniversitiesMutation,
} from '../../../../../../redux/services/erasmusConsortium';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import { useGetErasmusUniversitiesQuery } from '../../../../../../redux/services/erasmusUniversities';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const ErasmusConsortiumEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isPreview = mode === 'preview';
  const { data: consortiumDetail, isLoading } = useGetErasmusConsortiumQuery(
    id,
    {
      skip: !isEdit && !isPreview,
    },
  );
  const { saveSuccess: toastSaveSuccess, apiErrorMessage } = useToastMessages();
  const [saveErasmusConsortium] = useSaveErasmusConsortiumMutation();
  const { refetch } = useGetErasmusConsortiumsQuery();
  const { data: universities } = useGetErasmusUniversitiesQuery();
  const [saveConsortiumUniversities] =
    useSaveErasmusConsortiumUniversitiesMutation();
  const [filteredUniversities, setFilteredUniversities] = useState();

  useEffect(() => {
    if (consortiumDetail) {
      setFilteredUniversities(consortiumDetail?.consortium.universities || []);
    }
  }, [consortiumDetail]);

  const handleConsortiumUniDelete = (deletedUniversity) => {
    const data = filteredUniversities.filter(
      (university) => university.id !== deletedUniversity.university_id,
    );
    setFilteredUniversities(data);
  };

   const title = (isCreate && t('Pridanie konzorcia')) || t('Úprava konzorcia');

  if (isLoading || (isEdit && !consortiumDetail) || !universities) {
    return <Spinner />;
  }

  const initials =
    isEdit || isPreview
      ? {
          ...consortiumDetail.consortium,
        }
      : {
          name: undefined,
        };

  if (!initials) {
    return <Spinner />;
  }
  return (
    <>
      {isPreview ? null : (
        <AppBarCMS
          title={title}
          backUrl={routes.cmsErasmusConsortium}
          backUrlTooltip={t('Konzorciá')}
          permissionsBasic={'erasmus-applications'}
        />
      )}
      <div style={{ margin: '10px' }}>
        <ErasmusConsortiumForm
          initials={initials}
          isEdit={isEdit}
          isPreview={isPreview}
          universities={universities}
          filteredUniversities={filteredUniversities}
          onConsortiumUniDelete={(row) => {
            handleConsortiumUniDelete(row.pivot);
            //deleteConsortiumUniversity(row.pivot)
          }}
          onSubmit={async (values) => {
            try {
              const existingUniversityIds = filteredUniversities
                ? filteredUniversities.map((item) => item.id)
                : [];
              const selectedUniversityIds = values.choosedUniversitiesIds || [];
              const choosedUniversitiesIds = [
                ...new Set([...existingUniversityIds, ...selectedUniversityIds]),
              ];

              const consortiumResponse = await saveErasmusConsortium({
                body: values,
                id: id,
              }).unwrap();

              const consortiumId = id ?? consortiumResponse?.consortium?.id;

              if (consortiumId) {
                await saveConsortiumUniversities({
                  body: choosedUniversitiesIds,
                  id: consortiumId,
                }).unwrap();
              }

              toastSaveSuccess();
              navigate(routes.cmsErasmusConsortium);
              refetch();
            } catch (error) {
              apiErrorMessage(error);
            }
          }}
        />
      </div>
    </>
  );
};

export default ErasmusConsortiumEdit;
